module.exports = __webpack_public_path__ + "img/desktop-shortage-modal-img.9a7c1e93.png";